import React from "react";
import DistrictForm from "./DistrictForm";

export default function DistrictEdit() {
  return <DistrictForm mode="edit" />;
}
